import { Dayjs } from 'dayjs'
import { request } from '../request'
import { Province } from '@models/api/Province'
import { AxiosResponse } from 'axios'
import { FileType } from '@enums/FileType'
import { formatDB } from '@services/DateService'

export const lightning = {
  getLightnings: (
    initDate: Dayjs,
    endDate: Dayjs,
    province: Province['NATCODE'],
    format: FileType.EXCEL | FileType.KMZ | FileType.SHAPE
  ) => {
    return request.get(`lightning/getLightnings`, {
      params: {
        init_date: initDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD'),
        id_province: province,
        format: format
      },
      responseType: 'blob'
    })
  },

  getProvinces: (): Promise<AxiosResponse<Province[]>> => {
    return request.get('lightning/getProvinces')
  },

  getStormPredictions: (
    date: Dayjs
  ) /* : Promise<AxiosResponse<StormDTO[]>>*/ => {
    /* return request.get('lightning/getStormPredictions', {
      params: {
        date: date.format(formatDB)
      }
    })*/
    const url = `${
      request.defaults.baseURL
    }/lightning/getStormPredictions?date=${date.utc().format(formatDB)}`
    return url
  }
}
